import { ContentBlock } from './content-block';

export class ContentBlockViewComponent<BlockT extends ContentBlock = ContentBlock> {
    block: BlockT;
}
